module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p1-B-B-db990fd0f0680559f83071f94a66987b.png";